import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import CountrySelect from '../../../components/ui/CountrySelect';

const BasicProfileForm = ({ formData, onChange, errors }) => {
  const partnerTypes = [
    { value: 'oem', label: 'OEM' },
    { value: 'distributor', label: 'Distributor' },
    { value: 'system-integrator', label: 'System Integrator' },
    { value: 'contractor', label: 'Contractor' },
    { value: 'consultant', label: 'Consultant' },
    { value: 'cloud-provider', label: 'Cloud Provider' }
  ];

  const ownershipStructures = [
    { value: 'private', label: 'Private Limited' },
    { value: 'public', label: 'Public Limited' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'sole-proprietor', label: 'Sole Proprietorship' },
    { value: 'llc', label: 'Limited Liability Company' }
  ];

  return (
    <div className="space-y-24">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <Input
          label="Legal Name"
          type="text"
          placeholder="Enter legal company name"
          required
          value={formData?.legalName}
          onChange={(e) => onChange('legalName', e?.target?.value)}
          error={errors?.legalName}
        />

        <Input
          label="Brand Name"
          type="text"
          placeholder="Enter brand/trading name"
          value={formData?.brandName}
          onChange={(e) => onChange('brandName', e?.target?.value)}
          error={errors?.brandName}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <Select
          label="Partner Type"
          placeholder="Select partner type"
          required
          options={partnerTypes}
          value={formData?.partnerType}
          onChange={(value) => onChange('partnerType', value)}
          error={errors?.partnerType}
        />

        <CountrySelect
          label="Country/Region"
          placeholder="Select country"
          required
          value={formData?.country}
          onChange={(value) => onChange('country', value)}
          error={errors?.country}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <Input
          label="Website"
          type="url"
          placeholder="https://www.example.com"
          value={formData?.website}
          onChange={(e) => onChange('website', e?.target?.value)}
          error={errors?.website}
        />

        <Input
          label="Year Established"
          type="number"
          placeholder="YYYY"
          min="1900"
          max={new Date()?.getFullYear()}
          value={formData?.yearEstablished}
          onChange={(e) => onChange('yearEstablished', e?.target?.value)}
          error={errors?.yearEstablished}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <Select
          label="Ownership Structure"
          placeholder="Select ownership type"
          required
          options={ownershipStructures}
          value={formData?.ownershipStructure}
          onChange={(value) => onChange('ownershipStructure', value)}
          error={errors?.ownershipStructure}
        />

        <Input
          label="Tax ID / CR / VAT No"
          type="text"
          placeholder="Enter registration number"
          required
          value={formData?.taxId}
          onChange={(e) => onChange('taxId', e?.target?.value)}
          error={errors?.taxId}
        />
      </div>
      <Input
        label="Authorized Signatory"
        type="text"
        placeholder="Full name of authorized person"
        required
        value={formData?.authorizedSignatory}
        onChange={(e) => onChange('authorizedSignatory', e?.target?.value)}
        error={errors?.authorizedSignatory}
      />
    </div>
  );
};

export default BasicProfileForm;